import { Button } from '@progress/kendo-react-buttons'
import { FC, MouseEvent } from 'react'

export interface ReferenceCommandCellProps {
  data: { code: string, name: string, inEdit?: boolean }
  onClick?: (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => void
}

export const ReferenceCommandCell: FC<ReferenceCommandCellProps> = ({
  data,
  onClick
}) => {
  const handleOnClick = (
    e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => {
    onClick?.(e)
  }

  return (
    <td className="k-command-cell">
      <Button
        themeColor={'primary'}
        fillMode="link"
        onClick={handleOnClick}
        style={{ whiteSpace: 'normal', textAlign: 'left' }}
      >
        {data.name}
      </Button>
    </td>
  )
}
